exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".item-title{font-weight:600;font-size:20px;margin-bottom:5px}.item-price{color:#129066;font-size:26px}.item-multi-price .item-price{color:#129066;font-size:20px}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/sharedComponents/item/Title.vue"],"names":[],"mappings":"AACA,YACE,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACpB,AACD,YACE,cAAe,AACf,cAAgB,CACjB,AACD,8BACE,cAAe,AACf,cAAgB,CACjB","file":"Title.vue","sourcesContent":["\n.item-title{\n  font-weight: 600;\n  font-size: 20px;\n  margin-bottom: 5px;\n}\n.item-price{\n  color: #129066;\n  font-size: 26px;\n}\n.item-multi-price .item-price{\n  color: #129066;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c8ea7fc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/painel/sharedComponents/item/Title.vue
// module id = 620
// module chunks = 2